// extracted by mini-css-extract-plugin
module.exports = {"successModal":"EmailAddressChangePanel_successModal__2uu9s","header":"EmailAddressChangePanel_header__2I_3t","text":"EmailAddressChangePanel_text__r0w4A"};